export default __webpack_public_path__ + "static/brands@2x-84b17eb274282a210bbdf57abdda6758.png";